export const documentConstants = {
  REQUEST_START: 'REQUEST_START',
  REQUEST_STOP: 'REQUEST_STOP',
  REQUEST_ERROR: 'REQUEST_ERROR',
  FETCH_BOAT_DOCUMENTS: 'FETCH_BOAT_DOCUMENTS',
  FETCH_BOAT_DOCUMENTS_SUCCESS: 'FETCH_BOAT_DOCUMENTS_SUCCESS',
  FETCH_BOAT_DOCUMENTS_ERROR: 'FETCH_BOAT_DOCUMENTS_ERROR',
  FETCH_BOAT_DOCUMENTS_FOR_EQUIPMENT: 'FETCH_BOAT_DOCUMENTS_FOR_EQUIPMENT',
  FETCH_BOAT_DOCUMENTS_FOR_EQUIPMENT_SUCCESS: 'FETCH_BOAT_DOCUMENTS_FOR_EQUIPMENT_SUCCESS',
  FETCH_BOAT_DOCUMENTS_FOR_EQUIPMENT_ERROR: 'FETCH_BOAT_DOCUMENTS_FOR_EQUIPMENT_ERROR',

  FETCH_DOCUMENTS_FOR_DASHBOARD: 'FETCH_DOCUMENTS_FOR_DASHBOARD',
  FETCH_DOCUMENTS_FOR_DASHBOARD_SUCCESS: 'FETCH_DOCUMENTS_FOR_DASHBOARD_SUCCESS',
  FETCH_DOCUMENTS_FOR_DASHBOARD_ERROR: 'FETCH_DOCUMENTS_FOR_DASHBOARD_ERROR',

  SAVING_NEW_DOCUMENT: 'SAVING_NEW_DOCUMENT',
  SAVING_NEW_DOCUMENT_SUCCESS: 'SAVING_NEW_DOCUMENT_SUCCESS',
  SAVING_NEW_DOCUMENT_ERROR: 'SAVING_NEW_DOCUMENT_ERROR',

  SAVING_DOCUMENTS_LOADING: 'SAVING_DOCUMENTS_LOADING',
  SAVING_DOCUMENTS_SUCCESS: 'SAVING_DOCUMENTS_SUCCESS',
  SAVING_DOCUMENTS_ERROR: 'SAVING_DOCUMENTS_ERROR',

  FETCH_DOCUMENT_CATEGORIES: 'FETCH_DOCUMENT_CATEGORIES',
  FETCH_DOCUMENT_CATEGORIES_SUCCESS: 'FETCH_DOCUMENT_CATEGORIES_SUCCESS',
  FETCH_DOCUMENT_CATEGORIES_ERROR: 'FETCH_DOCUMENT_CATEGORIES_ERROR',

  FETCH_DOCUMENT_USER_CATEGORIES: 'FETCH_DOCUMENT_USER_CATEGORIES',
  FETCH_DOCUMENT_USER_CATEGORIES_SUCCESS: 'FETCH_DOCUMENT_USER_CATEGORIES_SUCCESS',
  FETCH_DOCUMENT_USER_CATEGORIES_ERROR: 'FETCH_DOCUMENT_USER_CATEGORIES_ERROR',

  RESET_DOCUMENTS: 'RESET_DOCUMENTS',

  UPDATE_DOCUMENT_DASHBOARD_STATUS: 'UPDATE_DOCUMENT_DASHBOARD_STATUS',
  UPDATE_DOCUMENT_DASHBOARD_STATUS_SUCCESS: 'UPDATE_DOCUMENT_DASHBOARD_STATUS_SUCCESS',
  UPDATE_DOCUMENT_DASHBOARD_STATUS_ERROR: 'UPDATE_DOCUMENT_DASHBOARD_STATUS_ERROR',
} as const
